import {Chip, Stack, Typography} from '@mui/material';
import {FC, useCallback, useMemo} from 'react';
import {styled} from 'styled-components';

import {getActiveFilters, useFilters} from '@website_frontend/lib/filters';

type Props = {
  count: number;
};

export const FilteredResultsHeader: FC<Props> = ({count}) => {
  const {filters, setFilter, removeTypeLabel} = useFilters();

  const activeFilters = useMemo(() => getActiveFilters(filters), [filters]);

  const handleRemoveFilter = useCallback(
    (paramName: string, value?: number | string) => {
      if (paramName === 'typeLabel' && value !== undefined) {
        // Remove the specific typeLabel from the array
        removeTypeLabel(value as string);
      } else {
        // Use setFilter with proper typing - we need to cast because paramName is a string
        // but setFilter expects a strongly typed FilterParamName
        // biome-ignore lint/suspicious/noExplicitAny: paramName is validated at runtime
        setFilter(paramName as any, undefined);
      }
    },
    [setFilter, removeTypeLabel]
  );

  return (
    <Wrapper>
      {activeFilters.length > 0 && (
        <>
          <Typography variant="subtitle1">{count.toLocaleString()} éléments</Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" justifyContent="center" useFlexGap>
            {activeFilters.map((filter, index) => (
              <Chip
                key={
                  filter.paramName === 'typeLabel'
                    ? `typeLabel-${filter.value}-${index}`
                    : filter.paramName
                }
                label={filter.label}
                onDelete={() => handleRemoveFilter(filter.paramName, filter.value)}
                size="small"
                variant="filled"
              />
            ))}
          </Stack>
        </>
      )}
    </Wrapper>
  );
};
FilteredResultsHeader.displayName = 'FilteredResultsHeader';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;
